var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Frohe Weihnachten")]),_c('div',{staticClass:"cards-wrapper"},[_c('ul',{staticClass:"cards"},_vm._l((_vm.days),function(i){return _c('li',{key:i,staticClass:"card",class:{'visited': _vm.visited(i)}},[_c('div',{staticClass:"link",on:{"click":function($event){return _vm.toDay(i)}}},[_vm._v(" "+_vm._s(i)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }